import React, { useEffect, useState } from "react";
import "./styles.sass";
import JoditEditor from "jodit-react";
import { Context } from "../..";
import Emptiness from "../../components/UI/emptiness/Emptiness";
import Spinner from "../../components/UI/spinner/Spinner";
import Timofey from "../../assets/images/Timofey_avatar.png";
import Button from "../../components/UI/button/GgButton";
import CONSTANTS from "../../utils/constants";
import Input from "../../components/UI/input/GgInput";
import Modal from "../../components/modal/Modal";
import { useModal } from "../../customHooks/useModal";
import Switch from "../../components/UI/switch/Switch";
import { Editor } from "../../components/UI/editor/QuillEditor";

interface ISiteContent {
  _id?: string | undefined;
  title?: string;
  content?: string;
}

function SiteSettings() {
  const { site, store, roles } = React.useContext(Context);
  const [adminPermissionData, setAdminPermissionData] = useState<any>()

  const [formData, setFormData] = React.useState<ISiteContent[]>([]);
  const [originalFormData, setOriginalFormData] = React.useState<
    ISiteContent[]
  >([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [privacyPolicy, setPrivacyPolicy] = React.useState<string>("");
  const [selectedCard, setSelectedCard] = React.useState<any>(null);

  const modal = useModal();

  const stateNameLookup = {
    nsw: "New South Wales",
    vic: "Victoria",
    qld: "Queensland",
    sa: "South Australia",
    tas: "Tasmania",
    nt: "Northern Territory",
    act: "Australian Capital Territory",
    wa: "Western Australia",
  } as any;

  useEffect(() => {
    site
      .loadList()
      .then((res: any) => {
        setFormData(res);
        setOriginalFormData(res);
        // if needed to get content by title

        // const content = Object.fromEntries(
        //   res.map((item: any) => [item.title, item.content])
        // );
        // console.log({ content });

        setPrivacyPolicy(res?.[0]?.content?.[0]);
        setLoading(false);
      })
      .catch(console.log);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site]);

  const updatePrivacyPolicy = () =>
    site.updateOne(CONSTANTS.privacyPolicy, { content: privacyPolicy });

  const showSelectedCard = (item: ISiteContent) => {
    if (item?._id === selectedCard?._id) {
      console.log(item?._id, selectedCard?._id)
      setSelectedCard(null);
    } else {
      console.log(item, ">>>>>>>>>>>>>>")
      setSelectedCard(item);
    }
  };

  const handleChangeContent = (val: string, index: number, key: string) => {
    let modifiedSelected = { ...selectedCard };
    const newFormData = formData.map((item) => {
      if (item._id === selectedCard._id) {
        // @ts-ignore
        item.content[index][key] = val;
        modifiedSelected = item;
      }
      return item;
    });
    setSelectedCard(modifiedSelected);
    setFormData(newFormData);
  };

  const handleUpdateContent = () => {
    site
      .updateOne(selectedCard?.title, { content: selectedCard?.content })
      .then(() => setSelectedCard(null))
      .catch(console.log);
  };

  useEffect(()=>{
  },[originalFormData,formData])
  
  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "site")?.children?.find((child: any) => child.path === "site-settings")
    setAdminPermissionData(userData)
  };

  useEffect(() => {
    loadNewData()
  }, [])

  return (
    <>
      {formData.length > 0 && !loading ? (
        <>
        {/* TODO: removing edit feature */}
          {/* <div className="title">Privacy Policy</div>
          {adminPermissionData.edit ? 
            <Editor
            value={privacyPolicy}
            onChange={(value) => setPrivacyPolicy(value)}
            placeholder="Enter content"
            style={{
              height: "16rem",
              marginBottom: "3rem",
            }}
            actionData={adminPermissionData}
          />
        : ""} */}
          
          {/* <div className="btn-container">
            {adminPermissionData?.edit ? 
            <Button
            // className="button"
            label="Save"
            onPress={updatePrivacyPolicy}
          /> : ""
          }
          </div> */}

          <div className="title">
            Eligibility Criteria
            <span>(click on the card to edit)</span>
          </div>
          <div className="card-container">
            {formData?.slice(1)?.map((item: any, index: number) => (
              <div
                key={index}
                onClick={() => showSelectedCard(item)}
                className="card"
              >
                <div className="card-title">
                  {
                    stateNameLookup[
                      item?.title.replace("eligibility-criteria-", "")
                    ]
                  }
                </div>
              </div>
            ))}
          </div>
        </>
      ) : formData?.length === 0 && !loading ? (
        <Emptiness icon={Timofey} content="No content!" />
      ) : (
        <div className="spinner-container">
          <Spinner />
        </div>
      )}
      <Modal
        show={selectedCard !== null}
        onClose={() => {
          setFormData(originalFormData);
          setSelectedCard(null);
        }}
        title={`Edit content of ${
          stateNameLookup?.[
            selectedCard?.title?.replace("eligibility-criteria-", "")
          ]
        }`}
        showSubmit
        onSubmit={() => handleUpdateContent()}
      >
        <div className="content-container">
          {selectedCard?.content?.map((content: any, index: number) => (
            <div
              key={index}
              style={{
                paddingBottom: "2rem",
              }}
            >
              <h4>Title</h4>
              <Input
                type="text"
                placeholder="Enter title"
                value={content?.heading}
                onChange={(val) => handleChangeContent(val, index, "heading")}
                disabled={!adminPermissionData?.edit}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h4>Content</h4>
              </div>

              <Editor
                value={content?.content}
                onChange={(val) => handleChangeContent(val, index, "content")}
                placeholder="Enter content"
                readOnly={!adminPermissionData?.add && !adminPermissionData?.edit}

              />
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
}

export default SiteSettings;
